import React from 'react';
import { RadarIcon, BellIcon } from 'lucide-react';
type HeaderProps = {
  onProfileClick: () => void;
};
export function Header({
  onProfileClick
}: HeaderProps) {
  return <header className="bg-slate-950 border-b border-slate-800 px-6 py-4" data-id="element-175">
      <div className="max-w-7xl mx-auto flex items-center justify-between" data-id="element-176">
        <div className="flex items-center gap-3" data-id="element-177">
          <div className="p-2 bg-amber-500/10 rounded-lg" data-id="element-178">
            <RadarIcon className="w-8 h-8 text-amber-500" data-id="element-179" />
          </div>
          <div data-id="element-180">
            <h1 className="text-xl font-bold text-white tracking-tight" data-id="element-181">
              China Innovation Cockpit
            </h1>
            <p className="text-sm text-slate-400" data-id="element-182">
              Your Command Center for China's Innovation Landscape
            </p>
          </div>
        </div>

        <div className="flex items-center gap-4" data-id="element-183">
          <button className="p-2 text-slate-400 hover:text-white hover:bg-slate-800 rounded-lg transition-colors" aria-label="Notifications" data-id="element-184">
            <BellIcon className="w-5 h-5" data-id="element-185" />
          </button>
          <button onClick={onProfileClick} className="rounded-full ring-2 ring-transparent hover:ring-amber-500/50 transition-all" aria-label="User profile" data-id="element-186">
            <img src="https://cdn.magicpatterns.com/uploads/8LVD9QTLxrXiDXCudb2s1j/daniel.jpg" alt="Daniel Frerichs" className="w-9 h-9 rounded-full object-cover" data-id="element-187" />
          </button>
        </div>
      </div>
    </header>;
}